(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/win-div/assets/javascripts/win-div-hvs-mobile.js') >= 0) return;  svs.modules.push('/components/tipsen/win-div/assets/javascripts/win-div-hvs-mobile.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  useMemo = _React.useMemo;
const ReactIcon = svs.ui.ReactIcon;
const currency = svs.utils.format.Currency;
const useCombinedDrawAndPlayerWinDivs = svs.components.tipsen.winDiv.useCombinedDrawAndPlayerWinDivs;
const _svs$components$tipse = svs.components.tipsen.winDiv.utils,
  getCombinedWinDivAlteredForMobile = _svs$components$tipse.getCombinedWinDivAlteredForMobile,
  getBestRowText = _svs$components$tipse.getBestRowText,
  getPlayersCorrectAmountText = _svs$components$tipse.getPlayersCorrectAmountText;
const getWinDivListRowClassNames = _ref => {
  let branding = _ref.branding,
    _ref$playerWins = _ref.playerWins,
    playerWins = _ref$playerWins === void 0 ? 0 : _ref$playerWins,
    isBestWinDiv = _ref.isBestWinDiv,
    winValue = _ref.winValue,
    isOnlyForCollapsedView = _ref.isOnlyForCollapsedView,
    isPlayersBestWinDiv = _ref.isPlayersBestWinDiv,
    _ref$isMultiForecastC = _ref.isMultiForecastChoiceOnCorrectResult,
    isMultiForecastChoiceOnCorrectResult = _ref$isMultiForecastC === void 0 ? true : _ref$isMultiForecastC;
  const blockName = 'pg_windiv_grid';
  const classNames = [blockName];
  if (branding && branding.length > 0) {
    classNames.push("".concat(blockName, "--").concat(branding));
  }
  !(isBestWinDiv || isPlayersBestWinDiv) && classNames.push("".concat(blockName, "--hidden-on-collapsed"));
  if (isBestWinDiv) {
    const blockAndElementName = "".concat(blockName, "__best_row");
    classNames.push(blockAndElementName);
    isOnlyForCollapsedView && classNames.push("".concat(blockAndElementName, "--hidden-on-expanded"));
  }
  if (playerWins > 0 && winValue > 0 && !isOnlyForCollapsedView && isMultiForecastChoiceOnCorrectResult) {
    classNames.push("".concat(blockName, "__highlighted"));
    if (branding && branding.length > 0) {
      classNames.push("".concat(blockName, "__highlighted--").concat(branding));
    }
  }
  if (isPlayersBestWinDiv && !isOnlyForCollapsedView) {
    const blockAndElementName = "".concat(blockName, "__my_best_row");
    classNames.push(blockAndElementName);
    !winValue && classNames.push("".concat(blockAndElementName, "--no_win"));
  }
  return classNames;
};
const WinDivHvsMobile = _ref2 => {
  let branding = _ref2.branding,
    drawWinDivs = _ref2.drawWinDivs,
    playerWinDivs = _ref2.playerWinDivs,
    _ref2$drawEventsLengt = _ref2.drawEventsLength,
    drawEventsLength = _ref2$drawEventsLengt === void 0 ? 13 : _ref2$drawEventsLengt,
    className = _ref2.className,
    children = _ref2.children,
    hasMultiForecastChoice = _ref2.hasMultiForecastChoice,
    isGroup = _ref2.isGroup,
    hasPlayerWinDivs = _ref2.hasPlayerWinDivs,
    isMultiForecastChoiceOnCorrectResult = _ref2.isMultiForecastChoiceOnCorrectResult;
  const _useState = useState(hasMultiForecastChoice),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  const combinedWinDivs = useCombinedDrawAndPlayerWinDivs({
    playerWinDivs,
    drawWinDivs
  });
  const classNamesWinDiv = ['pg_windiv'];
  className && classNamesWinDiv.push(className);
  const classNamesWinDivList = ['pg_windiv_list'];
  classNamesWinDivList.push("".concat(classNamesWinDivList[0], "--").concat(isExpanded ? 'expanded' : 'collapsed'));
  const combinedWinDivsAlteredForMobile = useMemo(() => getCombinedWinDivAlteredForMobile(combinedWinDivs, playerWinDivs), [combinedWinDivs, playerWinDivs]);
  return React.createElement("section", null, React.createElement("div", {
    className: classNamesWinDiv.join(' ')
  }, React.createElement("div", {
    className: classNamesWinDivList.join(' ')
  }, combinedWinDivsAlteredForMobile.map(_ref3 => {
    let winDiv = _ref3.winDiv,
      winners = _ref3.winners,
      winValue = _ref3.winValue,
      playerWins = _ref3.playerWins,
      isBestWinDiv = _ref3.isBestWinDiv,
      isPlayersBestWinDiv = _ref3.isPlayersBestWinDiv,
      isOnlyForCollapsedView = _ref3.isDuplicated;
    const shouldShowTotalCorrects = isExpanded ? typeof winners === 'number' : !isPlayersBestWinDiv;
    return React.createElement("div", {
      className: getWinDivListRowClassNames({
        branding,
        isBestWinDiv,
        isPlayersBestWinDiv,
        playerWins,
        isOnlyForCollapsedView,
        winValue,
        isMultiForecastChoiceOnCorrectResult
      }).join(' '),
      key: "".concat(winDiv, "_").concat(isPlayersBestWinDiv, "_").concat(isOnlyForCollapsedView)
    }, (isBestWinDiv || isPlayersBestWinDiv) && React.createElement("span", {
      className: "pg_windiv_grid__best_row_text"
    }, getBestRowText({
      isBestWinDiv,
      isPlayersBestWinDiv,
      isGroup,
      isOnlyForCollapsedView
    })), React.createElement("span", {
      className: "pg_windiv_grid__correct_amounts"
    }, "".concat(drawEventsLength - (winDiv - 1), " r\xE4tt")), React.createElement("span", {
      className: "pg_windiv_grid__win_commission"
    }, "".concat(currency(winValue) || 0, " kr")), shouldShowTotalCorrects && React.createElement("div", {
      className: "pg_windiv_grid__correct_rows"
    }, "".concat(currency(winners), " st")), !isOnlyForCollapsedView && React.createElement("div", {
      className: "pg_windiv_grid__my_correct_rows"
    }, getPlayersCorrectAmountText(playerWins, isGroup, isExpanded, hasPlayerWinDivs)));
  }))), children, React.createElement("div", {
    className: "expand-container"
  }, React.createElement("button", {
    className: "expand-button",
    onClick: () => {
      setIsExpanded(!isExpanded);
    },
    type: "button"
  }, React.createElement("span", {
    className: "f-400 margin-xs-bottom"
  }, "".concat(isExpanded ? 'Visa mindre' : 'Visa hela utdelningen')), React.createElement(ReactIcon, {
    color: "fc-white",
    icon: isExpanded ? 'menu-up' : 'menu-down',
    size: "200"
  }))));
};
setGlobal('svs.components.tipsen.winDiv.WinDivHvsMobile', WinDivHvsMobile);

 })(window);